import React from 'react';
import { useMutation, gql } from '@apollo/client';
import { FeatureFlags } from '../../../components/FeatureFlags';
import { enqueueSnackbar } from 'notistack';

const adminUpdateOrganizationFeatureFlagsMutation = gql`
  mutation AdminUpdateOrganizationFeatureFlags(
    $input: AdminUpdateOrganizationInput!
  ) {
    adminUpdateOrganization(input: $input) {
      organization {
        id
        featureFlags
      }
    }
  }
`;

interface FeatureFlagsPanelProps {
  organization: {
    id: string;
    featureFlags: Record<string, boolean>;
  };
}

export const FeatureFlagsPanel: React.FC<FeatureFlagsPanelProps> = ({
  organization,
}) => {
  const [updateOrganization] = useMutation(
    adminUpdateOrganizationFeatureFlagsMutation,
    {
      onCompleted: () => {
        enqueueSnackbar('Organization feature flags updated', {
          variant: 'success',
        });
      },
      onError: (error) => {
        console.error(error);
        enqueueSnackbar('Error updating organization feature flags', {
          variant: 'error',
        });
      },
    }
  );

  return (
    <FeatureFlags
      initialValues={organization.featureFlags}
      update={(flag, value) => {
        updateOrganization({
          variables: {
            input: {
              id: organization.id,
              featureFlags: {
                [flag]: value,
              },
            },
          },
        });
      }}
    />
  );
};
